import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'descriptionLines', standalone: true })
export class DescriptionLinesPipe implements PipeTransform {
	transform(value: string | null | undefined): string {
		if (!value) return '';
		return value
			.replaceAll('\r\n', '\n')
			.replaceAll('\r', '\n')
			.trim();
	}
}
